import React from 'react'
import { Input } from '@drifthq/tide-core'

import './style.css'

const Consent = ({ checked, onChange }) => {
  return (
    <div className="start-consent">
      <div>
        <Input
          type="checkbox"
          checked={checked}
          onChange={onChange}
        />
      </div>
      <div className="start-consent-copy">
        <p>
          By entering your email, you agree that we may send you emails about Drift’s upcoming services and promotions. You may unsubscribe at any time.
          See our <a rel="noopener noreferrer" target="_blank" href="https://www.drift.com/privacy-policy/"> Privacy Policy</a>
        </p>
      </div>
    </div>
  )
}

export default Consent



// WEBPACK FOOTER //
// ./src/components/Consent/index.js